import dayjs from "dayjs";
import type { Dayjs } from "dayjs";

// Избраната от antd DatePicker дата идва с час 00:00 — прикачаме ТЕКУЩИЯ час,
// за да пази операцията кога реално е въведена (списъците показват дата + час).
// При редакция префилнатата дата пази записания час; сменя се само при нов избор.
export const withCurrentTime = (d: Dayjs | null): Dayjs | null => {
  if (d == null) return d;
  const now = dayjs();
  return d.hour(now.hour()).minute(now.minute()).second(now.second());
};

// „15.07.2026 14:28" — за колоните „Дата" в списъчните таблици на модула.
// Ръчен формат: bg-BG locale добавя „ г." и датата се пренася на два реда.
export const fmtDateTime = (iso: string | null): string => {
  if (!iso) return "—";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return iso;
  const p = (n: number) => String(n).padStart(2, "0");
  return `${p(d.getDate())}.${p(d.getMonth() + 1)}.${d.getFullYear()} ${p(d.getHours())}:${p(d.getMinutes())}`;
};

// „15.07.2026" — само датата (документните дати в справките/модалите).
export const fmtDate = (iso: string | null): string => {
  if (!iso) return "—";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return iso;
  const p = (n: number) => String(n).padStart(2, "0");
  return `${p(d.getDate())}.${p(d.getMonth() + 1)}.${d.getFullYear()}`;
};
